module.exports = __webpack_public_path__ + "img/values.d6f0c48.jpg";